export default __webpack_public_path__ + "static/media/moodboard-milieu-aquatique.a5f30c10.pdf";